<template>
  <router-view />
</template>

<script lang="ts" setup>
// No additional logic needed for this simple layout
</script>
